import { useEffect, useState } from "react";

export const useRefreshCooldown = () => {
  const [secondsLeft, setSecondsLeft] = useState(0);

  const readCookie = () => {
    const match = document.cookie.match(/(?:^|;)\s*lastRefresh=(\d+)/);
    return match ? Number(match[1]) : null;
  };

  useEffect(() => {
    const check = () => {
      const last = readCookie();
      if (!last) {
        setSecondsLeft(0);
        return;
      }

      const diff = Date.now() - last;
      const remaining = 60_000 - diff;

      setSecondsLeft(remaining > 0 ? Math.ceil(remaining / 1000) : 0);
    };

    check();
    const id = setInterval(check, 1000);

    return () => clearInterval(id);
  }, []);

  return secondsLeft;
};
